// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import { ACCEPT_MAP } from './constants';

export function formatFileSize(bytes) {
  if (!bytes || bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function formatDateTime(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function validateFile(file, fileType, allowedMimes, maxBytes) {
  if (file.size > maxBytes) {
    return `File too large. Maximum is ${maxBytes / 1024 / 1024}MB.`;
  }
  const { ext, label } = ACCEPT_MAP[fileType];
  if (!ext.test(file.name)) {
    return `Please upload a valid ${label} file.`;
  }
  if (file.type && !allowedMimes.includes(file.type)) {
    return `Invalid file type. Expected ${label}.`;
  }
  return null; // valid
}
